class ToastNotification extends HTMLElement {
  constructor() {
    super();
    this.content = null;
    this.successIcon = null;
    this.errorIcon = null;
    this.infoIcon = null;
    this.warningIcon = null;
    this.delay = 3000;
  }

  connectedCallback() {
    this.content = this.querySelector('[data-ref="toast-content"]');
    this.content.setAttribute('role', 'status');
    this.content.setAttribute('aria-live', 'polite');
    this.content.setAttribute('aria-atomic', 'true');
    this.successIcon = this.querySelector('[data-ref="success-icon"]');
    this.errorIcon = this.querySelector('[data-ref="error-icon"]');
    this.infoIcon = this.querySelector('[data-ref="info-icon"]');
    this.warningIcon = this.querySelector('[data-ref="warning-icon"]');

    this.delay = 3000;

    document.addEventListener('toast:open', (e) => {
      this.open();

      switch (e.detail.type) {
        case 'success':
          this.setSuccessMode(e.detail.message);
          break;
        case 'error':
          this.setErrorMode(e.detail.message);
          break;
        case 'warning':
          this.setWarningMode(e.detail.message);
          break;
        default:
          this.setInfoMode(e.detail.message);
          break;
      }

      setTimeout(() => {
        this.close();
      }, this.delay);
    });
  }

  open() {
    // The custom drawer sits above the theme's default toast layer.
    const drawer = document.querySelector('cart-drawer.is-open');
    this.style.zIndex = drawer ? String(Math.max(10001, Number(getComputedStyle(drawer).zIndex) + 1 || 10001)) : '';
    // The Shopify draft preview bar covers the bottom of the viewport on both
    // drawer and full-cart pages. Keep all preview feedback visible above it.
    if (document.querySelector('#PBarNextFrame')) {
      this.style.top = 'max(20px, env(safe-area-inset-top))';
      this.style.bottom = 'auto';
      this.style.transform = 'translateX(-50%)';
    }
    this.classList.add('active');
  }

  close() {
    this.classList.remove('active');
    this.style.removeProperty('top');
    this.style.removeProperty('bottom');
    this.style.removeProperty('transform');
    this.style.removeProperty('z-index');
  }

  setInfoMode(message) {
    this.content.textContent = message || 'Information';
    this.resetState();
    this.classList.add('info');
  }

  setWarningMode(message) {
    this.content.textContent = message || 'Attention !';
    this.resetState();
    this.classList.add('warning');
  }

  setErrorMode(message) {
    this.content.textContent = message || 'Erreur !';
    this.resetState();
    this.classList.add('error');
  }

  setSuccessMode(message) {
    this.content.textContent = message || 'Succès !';
    this.resetState();
    this.classList.add('success');
  }

  resetState() {
    this.classList.remove('info');
    this.classList.remove('warning');
    this.classList.remove('error');
    this.classList.remove('success');
  }
}

if (!customElements.get('toast-notification')) {
  customElements.define('toast-notification', ToastNotification);
}
